/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ notes: NonNullable<unknown> }} Transcript_Export_Notes_LabelInputs */

const en_transcript_export_notes_label = /** @type {(inputs: Transcript_Export_Notes_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`NOTES: ${i?.notes}`)
};

const fr_transcript_export_notes_label = /** @type {(inputs: Transcript_Export_Notes_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`NOTES: ${i?.notes}`)
};

const de_transcript_export_notes_label = /** @type {(inputs: Transcript_Export_Notes_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ANMERKUNGEN: ${i?.notes}`)
};

const it_transcript_export_notes_label = /** @type {(inputs: Transcript_Export_Notes_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`NOTE: ${i?.notes}`)
};

const ru_transcript_export_notes_label = /** @type {(inputs: Transcript_Export_Notes_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ПРИМЕЧАНИЯ: ${i?.notes}`)
};

const es_transcript_export_notes_label = /** @type {(inputs: Transcript_Export_Notes_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`NOTAS: ${i?.notes}`)
};

const zh_cn2_transcript_export_notes_label = /** @type {(inputs: Transcript_Export_Notes_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`备注：${i?.notes}`)
};

const ja_transcript_export_notes_label = /** @type {(inputs: Transcript_Export_Notes_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`注記: ${i?.notes}`)
};

const hi_transcript_export_notes_label = /** @type {(inputs: Transcript_Export_Notes_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`टिप्पणियाँ: ${i?.notes}`)
};

const pt_pt2_transcript_export_notes_label = /** @type {(inputs: Transcript_Export_Notes_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`NOTAS: ${i?.notes}`)
};

/**
* | output |
* | --- |
* | "NOTES: {notes}" |
*
* @param {Transcript_Export_Notes_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_notes_label = /** @type {((inputs: Transcript_Export_Notes_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_Notes_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_transcript_export_notes_label(inputs)
	if (locale === "de") return de_transcript_export_notes_label(inputs)
	if (locale === "it") return it_transcript_export_notes_label(inputs)
	if (locale === "ru") return ru_transcript_export_notes_label(inputs)
	if (locale === "es") return es_transcript_export_notes_label(inputs)
	if (locale === "zh-CN") return zh_cn2_transcript_export_notes_label(inputs)
	if (locale === "ja") return ja_transcript_export_notes_label(inputs)
	if (locale === "hi") return hi_transcript_export_notes_label(inputs)
	if (locale === "pt-PT") return pt_pt2_transcript_export_notes_label(inputs)
	return en_transcript_export_notes_label(inputs)
});